import { render, staticRenderFns } from "./schooling.vue?vue&type=template&id=7a3c6d53&"
import script from "./schooling.vue?vue&type=script&lang=js&"
export * from "./schooling.vue?vue&type=script&lang=js&"
import style0 from "./schooling.vue?vue&type=style&index=0&id=7a3c6d53&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports